import { alpha, createTheme } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';
import { createElement } from 'react';
import {
  AppCheckboxCheckedIcon,
  AppCheckboxUncheckedIcon
} from './components/app-checkbox-icons';
import { colorTokens, designSystemTokens } from './tokens';

export const appTheme = createTheme({
  designSystem: designSystemTokens,
  palette: {
    mode: 'dark',
    primary: {
      main: '#1976d2',
      light: '#42a5f5',
      dark: '#0d47a1',
      contrastText: '#e8f3ff'
    },
    secondary: {
      main: '#a8a8a8',
      dark: '#8e8e8e',
      light: '#c2c2c2'
    },
    error: {
      main: '#f44336',
      light: '#ef5350',
      dark: '#b71c1c'
    },
    background: {
      default: colorTokens.slate950Alpha95,
      paper: colorTokens.slate900Alpha95
    }
  },
  typography: {
    button: {
      textTransform: 'none',
      fontWeight: 600,
      letterSpacing: '0.01em'
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          '&.Mui-disabled': {
            cursor: 'not-allowed',
            pointerEvents: 'auto'
          }
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            cursor: 'not-allowed',
            pointerEvents: 'auto'
          }
        }
      }
    },
    MuiTextField: {
      defaultProps: {
        size: 'small'
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: colorTokens.whiteAlpha12
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: (theme: Theme) =>
              theme.designSystem.button.primaryBorderHover
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: (theme: Theme) => theme.designSystem.button.primaryBorder,
            borderWidth: 1.5
          },
          '&.Mui-focused': {
            boxShadow: (theme: Theme) =>
              `0 0 0 2px ${alpha(theme.designSystem.button.primaryBorderHover, 0.32)}`
          },
          '&.MuiInputBase-sizeSmall:not(.MuiInputBase-multiline)': {
            height: '45px'
          },
          '&.MuiInputBase-sizeMedium:not(.MuiInputBase-multiline)': {
            height: '50px'
          },
          '&.MuiInputBase-multiline': {
            padding: 0
          }
        },
        input: {
          padding: '10px 14px'
        },
        inputMultiline: {
          padding: '10px 14px'
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: (theme: Theme) => theme.designSystem.button.primaryBorderHover
          }
        }
      }
    },
    MuiCheckbox: {
      defaultProps: {
        icon: createElement(AppCheckboxUncheckedIcon),
        checkedIcon: createElement(AppCheckboxCheckedIcon)
      }
    }
  }
});
